import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF],
  strings: ['DV_DP_see_more'] as const,
}
